import type { ReactNode } from 'react';
import { RotateCw } from 'lucide-react';
import { ApiError } from '@/lib/api';
import { cn } from '@/lib/utils';
import { Button } from './button';

/** Tela vazia é convite para agir: diz o que aparece aqui e como começar. */
export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: {
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('flex flex-col items-center justify-center px-6 py-14 text-center', className)}>
      {icon && (
        <div className="mb-4 flex size-11 items-center justify-center rounded-panel bg-raised text-fg-muted [&_svg]:size-5">
          {icon}
        </div>
      )}
      <p className="text-[15px] font-medium">{title}</p>
      {description && <p className="mt-1.5 max-w-sm text-[13.5px] text-fg-muted">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function ErrorState({
  error,
  onRetry,
  className,
}: {
  error: unknown;
  onRetry?: () => void;
  className?: string;
}) {
  const message = error instanceof ApiError ? error.message : 'Não foi possível carregar.';
  return (
    <div
      role="alert"
      className={cn('flex flex-col items-center justify-center px-6 py-14 text-center', className)}
    >
      <p className="text-[15px] font-medium">Não carregou</p>
      <p className="mt-1.5 max-w-sm text-[13.5px] text-fg-muted">{message}</p>
      {onRetry && (
        <Button className="mt-5" size="sm" onClick={onRetry}>
          <RotateCw /> Tentar de novo
        </Button>
      )}
    </div>
  );
}
